exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"menuText": "#364254",
	"menuActiveText": "#0474EF",
	"subMenuActiveText": "#0474EF",
	"menuBg": "#fff",
	"menuHover": "#E6F7FF",
	"subMenuBg": "#fff",
	"subMenuHover": "#E6F7FF",
	"sideBarWidth": "210px"
};